const PROJECT_PERMISSION_BY_CAPABILITY = {
  delete: "project:delete",
  publish: "project:publish",
  update: "project:update",
  view: "project:read"
};

export function normalizeProjectAuthorization(project) {
  const source = project && typeof project === "object" ? project : {};
  const authorization =
    source.authorization && typeof source.authorization === "object" ? source.authorization : source;
  if (Array.isArray(authorization.permissions)) {
    return { permissions: authorization.permissions.filter(permission => typeof permission === "string") };
  }
  const capabilities =
    authorization.capabilities && typeof authorization.capabilities === "object"
      ? authorization.capabilities
      : source.capabilities && typeof source.capabilities === "object"
      ? source.capabilities
      : {};
  return {
    permissions: Object.entries(PROJECT_PERMISSION_BY_CAPABILITY)
      .filter(([capability]) => capabilities[capability] === true)
      .map(([, permission]) => permission)
      .sort()
  };
}

export function hasProjectPermission(project, permission) {
  return normalizeProjectAuthorization(project?.authorization || project).permissions.includes(permission);
}

export function resolveScopedProjectUnavailable(error) {
  const status = error?.status || error?.response?.status;
  if (status !== 404) return { unavailable: false };
  return {
    unavailable: true,
    title: "Project unavailable",
    message: "This Project is unavailable or you no longer have access to it.",
    actionLabel: "Return to Hub"
  };
}
